import * as React from 'react';
import { StaticPageWrapper, IStaticPageWrapperProps, centeredMessageStyle } from 'components/static-pages/StaticPageWrapper';


export const VitabotPage = (props:IStaticPageWrapperProps) => {
	const vitabotUrl = `/sso/vitabot?access_token=${localStorage.getItem('token')}`;
	return (
		<StaticPageWrapper 
			backgroundImage="/res_sys/vitabot_splash.jpg"
			backgroundSize="cover" 
			{...props}
		>
			<div style={centeredMessageStyle}>
				<div style={{textAlign:'center',fontFamily:'Open Sans',fontWeight:900,fontSize:'32px',color:'#263692', paddingTop:'20px', paddingBottom:'25px',lineHeight: '32px'}}>VITABOT</div>
				<div style={{textAlign:'center', marginTop:'0px', marginBottom:'25px'}}>
					<a target="_blank" aria-label={`GET STARTED, opens new tab`} href={vitabotUrl} className="go_button" style={{borderRadius:'40px',boxShadow: '2px 2px 4px 0px rgba(0,0,0,0.5)'}}>GET STARTED</a>
				</div>
				<div style={{fontSize:'18px',fontFamily:'Open Sans',fontWeight:600, fontStyle:'italic',color:'#4A4A4A', textAlign:'center',paddingBottom:'30px'}}>
					Track vitamins<br/>
					Use a cool app<br/>
					Manage your meal plans
				</div>
			</div>
		</StaticPageWrapper>
	)
};

